import React, { Component } from 'react';
import TVSlide from './TVSlide';
import { connect } from 'react-redux';
import { ConfettiContainer } from '../../components';
import { popFromAlertQueue, popFromNewShoutouts, leavePickWinnerMode } from '../../actions/TVModeAction';
import './TVAlertSlide.scss';

class TVAlertSlide extends Component {
  timeout = null;
  state = { shoutout: null, visible: true, shoutoutsQueue: [] };

  componentDidMount() {
    this.showNextShoutoutAlert();
    // if (this.props.shoutout) this.addShoutoutToAlertQueue(this.props.shoutout);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  showNextShoutoutAlert() {
    const { newShoutouts } = this.props;

    // Show the next shoutout in the queue, or if we are finished, return
    // to the regularly scheduled programming
    if (newShoutouts.length) {
      // If we already have a shoutout, we need to set visible to false
      // So that it will slide down, and set a timer for the next shoutout to slide back up
      if (this.state.shoutout) {
        this.setState({ visible: false });
        setTimeout(this.slideNextShoutoutIn.bind(this), 300);
      } else {
        // Otherwise, this is the first alerted shoutout in the queue,
        // so just slide that bad boy in
        this.slideNextShoutoutIn();
      }
    } else {
      // We've reached the end of the line
      this.setState({ shoutout: null, shoutoutsQueue: [], visible: false });
      this.props.popAlert();
    }
  }

  slideNextShoutoutIn() {
    const { duration, newShoutouts } = this.props;
    this.setState({ shoutout: newShoutouts[0], visible: true });
    this.timeout = setTimeout(() => {
      if (newShoutouts[0].winner) this.props.closeWinnerMode();
      this.props.popShoutout();
      this.showNextShoutoutAlert();
    }, duration);
  }

  renderShoutout() {
    const { history } = this.props;
    const { shoutout } = this.state;
    if (shoutout) {
      return (
        <TVSlide
          active
          light
          shoutout={shoutout}
          history={history}
        />
      );
    }
    return null;
  }

  render() {
    const { visible } = this.state;

    const className = visible ? 'tv-alert-wrapper visible' : 'tv-alert-wrapper';
    return (
      <div className={className}>
        <ConfettiContainer>
          {this.renderShoutout()}
        </ConfettiContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ tvModeStore }) => {
  const { newShoutouts } = tvModeStore;
  return { newShoutouts };
};


// don't know why I had to do it like this
const mapDispatchToProps = (dispatch) => {
  return {
    popShoutout: (() => {
      dispatch(popFromNewShoutouts());
    }),
    popAlert: (() => {
      dispatch(popFromAlertQueue());
    }),
    closeWinnerMode: (() => {
      dispatch(leavePickWinnerMode());
    })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TVAlertSlide);


// WEBPACK FOOTER //
// ./src/screens/tv/TVAlertSlide.js